const FETCH_FOLLOWING_USERS = 'library/FETCH_FOLLOWING_USERS';

const FETCH_FOLLOWING_FEEDS = 'library/FETCH_FOLLOWING_FEEDS';

const FETCH_STORIES = 'library/FETCH_STORIES';

const FETCH_COMMUNITY_POSTS = 'library/FETCH_COMMUNITY_POSTS';

const RESET_FOLLOWING_FEEDS = 'library/RESET_FOLLOWING_FEEDS';

const RESET_FOLLOWING_USERS = 'library/RESET_FOLLOWING_USERS';

const RESET_FOLLOWING_USER_STORIES = 'library/RESET_FOLLOWING_USER_STORIES';

const FETCH_READ_STORIES = 'library/FETCH_READ_STORIES';

const DELETE_READ_STORIES = 'library/DELETE_READ_STORIES';

const CHANGE_READ_STORIES_ORDER_TYPE = 'library/CHANGE_READ_STORIES_ORDER_TYPE';

const RESET_READ_STORIES = 'library/RESET_READ_STORIES';

const LIKE_COMMUNITY_POST = 'library/LIKE_COMMUNITY_POST';

const FETCH_LIKED_STORIES = 'library/FETCH_LIKED_STORIES';

const DELETE_LIKED_STORY = 'library/DELETE_LIKED_STORY';

export default {
  FETCH_FOLLOWING_USERS,
  FETCH_FOLLOWING_FEEDS,
  RESET_FOLLOWING_FEEDS,
  FETCH_STORIES,
  FETCH_COMMUNITY_POSTS,
  RESET_FOLLOWING_USERS,
  RESET_FOLLOWING_USER_STORIES,
  FETCH_READ_STORIES,
  DELETE_READ_STORIES,
  CHANGE_READ_STORIES_ORDER_TYPE,
  RESET_READ_STORIES,
  LIKE_COMMUNITY_POST,
  FETCH_LIKED_STORIES,
  DELETE_LIKED_STORY,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/library/types.js